import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { EmailBuilderService, FirebaseFunctionsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TEmail, TResponse } from '@shared/models';

type TFeedbackSubjects = 'Select a Subject' | 'Found Problem' | 'Request Feature' | 'Request Tutorial' |
    'General Question' | 'Technical Question' | 'Submit Testimonial' | 'Other';
type TFeedback = {
    'body': string;
    'critical': boolean;
    'criticalStr': string;
    'requestResponse': boolean;
    'requestResponseStr': string;
    'subject': TFeedbackSubjects;
    'priority': boolean;
    'priorityStr': string;
};

@Component({
    'selector': 'app-feedback',
    'templateUrl': './feedback.page.html',
    'styleUrls': ['./feedback.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class FeedbackPage extends ViewBasePage implements OnInit {
    public feedback: TFeedback;

    constructor(private emailBuilderService: EmailBuilderService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_FEEDBACK);
    }

    public override ngOnInit(): void {
        this.feedback = {
            'body': '',
            'requestResponse': false,
            'priority': false,
            'priorityStr': 'Not Urgent',
            'critical': false,
            'criticalStr': 'No',
            'requestResponseStr': 'No',
            'subject': 'General Question',
        }
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-feedback-tour');
    }

    public async onSubjectClick() {
        this.feedback.subject = this.feedback.subject || 'Select a Subject';
        const subjects = ['Found Problem', 'Request Feature', 'Request Tutorial', 'General Question',
            'Technical Question', 'Submit Testimonial', 'Other'];

        const response = await this.uxHelperService.showRadioAlert('Select Subject', subjects, this.feedback.subject);
        if (response.okay) {
            // this.feedback.subject = response.selectedItems?.[0] as TFeedbackSubjects;
            this.feedback.subject = response.selectedItems?.[0] as TFeedbackSubjects;
        }
    }

    public onRequestResponseChange() {
        this.feedback.requestResponseStr = (this.feedback.requestResponse) ? 'Yes' : 'No';
    }

    public onPriorityChange() {
        this.feedback.priorityStr = (this.feedback.priority) ? 'Urgent' : 'Not Urgent';
    }

    public async onSendEmailClick() {
        const user = this.sessionService.getCurrentUser();
        const accountNumber = this.sessionService.getAccountNumber();

        const subject = 'Feedback Subject: ' + this.feedback.subject;
        const userName = 'User Name = ' + user.firstName + ' ' + user.lastName;
        const userEmail = 'User Email = ' + user.email;
        const accountNum = 'Account Number = ' + accountNumber;
        const priority = 'Priority = ' + this.feedback.priorityStr;
        const requestResponse = 'Request Response = ' + this.feedback.requestResponseStr;
        const version = 'Version = ' + this.Constants.APPLICATION_VERSION;
        const feedback = 'User Feedback:';
        const separator = '--------';
        // const textBody = version + '\n' +
        //                 userName + '\n' +
        //                 userEmail + '\n' +
        //                 accountNum + '\n' +
        //                 subject + '\n' +
        //                 priority + '\n' +
        //                 requestResponse + '\n' +
        //                 separator + '\n' +
        //                 feedback + '\n' +
        //                 this.feedback.body;

        this.emailBuilderService.initializeEmailBody();
        this.emailBuilderService.setTitle(subject);
        this.emailBuilderService.addRow(version);
        this.emailBuilderService.addRow(userName);
        this.emailBuilderService.addRow(userEmail);
        this.emailBuilderService.addRow(accountNum);
        this.emailBuilderService.addRow(subject);
        this.emailBuilderService.addRow(priority);
        this.emailBuilderService.addRow(requestResponse);
        this.emailBuilderService.addRow(separator);
        this.emailBuilderService.addRow(feedback);
        this.emailBuilderService.addRow(this.feedback.body);
        this.emailBuilderService.finalizeEmailBody();

        const htmlBody = this.emailBuilderService.getHtml();
        // console.log(htmlBody);
        // const textBody = this.emailBuilderService.getText();

        const htmlEmail: TEmail = {
            'to': 'OneMinuteSystems@gmail.com',
            'subject': subject,
            'htmlBody': htmlBody
            // 'sendAs': 'html',
            // 'textBody': textBody,
        }
        // const textEmail: TEmail = {
        //     'subject': subject,
        //     'sendAs': 'text',
        //     'to': 'OneMinuteSystems@gmail.com',
        //     'textBody': textBody,
        //     'htmlBody': htmlBody
        // }

        try {
            await this.uxHelperService.showSpinner();
            await this.firebaseFunctionsService.sendEmail(htmlEmail);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showAlert('Information', 'Thank you for submitting your feedback.');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }
}
